import React from 'react'
import V2Layout from '../../components/V2Layout'
import SEO from '../../components/SEO'
import CapabilityPageNav from './CapabilityPageNav'
import CapabilitySections from './CapabilitySections'
import '../../versions/v2/capabilities.css'

const CleaningPage = () => (
    <V2Layout pageClass="pfc-capabilities">
        <SEO
            title="Precision Cleaning & Passivation"
            description="Precision cleaning, passivation and contamination control processes for flight-critical fluid control components."
        />
        <section className="pfc-page-hero">
            <div className="pfc-page-hero-inner">
                <p className="v2-section-label">Our Capabilities · 03</p>
                <h1 className="pfc-page-hero-title">Precision Cleaning &amp; Passivation</h1>
                
            </div>
        </section>

        <section className="cap-section">
            <div className="cap-section-inner">
                <div className="cap-callout-bar">
                    <div className="cap-callout-item">
                        <div className="cap-callout-label">Cleanliness Standard</div>
                        <div className="cap-callout-val">IEST-STD-CC1246E · Level 100+</div>
                    </div>
                    <div className="cap-callout-item">
                        <div className="cap-callout-label">Passivation Process</div>
                        <div className="cap-callout-val">Citric Acid</div>
                    </div>
                    <div className="cap-callout-item">
                        <div className="cap-callout-label">Clean Room</div>
                        <div className="cap-callout-val">ISO 7 (Class 10k) · 2,500 sq ft</div>
                    </div>
                    <div className="cap-callout-item">
                        <div className="cap-callout-label">Clean Work Area</div>
                        <div className="cap-callout-val">800 sq ft</div>
                    </div>
                </div>
                <div className="cap-cards-2">
                    <div className="cap-feature">
                        <strong>Robotic Cleaning System</strong>
                        <span>Automated parts cleaning and passivation cell ensures repeatable, validated cleanliness results on every component.</span>
                    </div>
                    <div className="cap-feature">
                        <strong>Clean Room</strong>
                        <span>Dedicated ISO 7 (Class 10,000) hard-wall environment for final cleaning, inspection, and packaging of cleanliness-critical assemblies.</span>
                    </div>
                    <div className="cap-feature">
                        <strong>Citric Passivation</strong>
                        <span>Environmentally preferred citric acid process removes free iron and forms a passive oxide layer for corrosion resistance.</span>
                    </div>
                    <div className="cap-feature">
                        <strong>Component-Level Verification</strong>
                        <span>Cleanliness verification performed at the piece-part level prior to assembly, supporting full traceability.</span>
                    </div>
                </div>
            </div>
        </section>

        <CapabilitySections slug="cleaning" />

        <CapabilityPageNav currentSlug="cleaning" />
    </V2Layout>
)

export default CleaningPage
